import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "./bestWriter.css";
import { useDispatch } from "react-redux";
import { sendBestWriterEmailRequest } from "../../../redux/reducers/ducks/adminReviewDuck";
import { getToasterNotifications } from "../../../utils/getToasterNotification";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export function WriterDescription({ showPopup, setShowPopup }) {
	const handleClose = () => {
		setShowPopup({
			isOpen: false,
			id: null,
			userId: null,
		});
	};

	const [password, setPassword] = React.useState();

	const dispatch = useDispatch();

	const handleBestWriter = () => {
		if (!password) {
			getToasterNotifications("Please enter password");
			return;
		} else {
			dispatch(
				sendBestWriterEmailRequest({
					reviewId: showPopup?.id,
					userId: showPopup?.userId,
					password: password,
				})
			);
			setShowPopup({
				isOpen: false,
				id: null,
				userId: null,
			});
		}
	};

	function BootstrapDialogTitle(props) {
		const { children, onClose, ...other } = props;

		return (
			<DialogTitle className="text-center" sx={{ m: 0, p: 2 }} {...other}>
				{children}
				{onClose ? (
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				) : null}
			</DialogTitle>
		);
	}

	React.useEffect(() => {
		setPassword();
	}, [showPopup]);

	return (
		<React.Fragment>
			<Dialog
				fullWidth
				maxWidth="sm"
				open={showPopup?.isOpen}
				className="best-writer-dialog"
				onClose={handleClose}
				aria-describedby="alert-dialog-slide-description"
			>
				<BootstrapDialogTitle
					id="customized-dialog-title"
					onClose={handleClose}
					className="text-center"
				>
					Enter password
				</BootstrapDialogTitle>
				<DialogContent>
					<form>
						<input
							required
							type="password"
							value={password}
							className="inputField w-100 admin-category-text-field"
							placeholder="Enter Password"
							onChange={(e) => {
								setPassword(e.target.value);
							}}
						/>
						<div className="text-center mt-2 ">
							<button
								type="submit"
								onClick={(e) => {
									e.preventDefault();
									handleBestWriter();
								}}
								className="btn addCategoryBtn px-5 py-2"
							>
								Submit
							</button>
						</div>
					</form>
				</DialogContent>
			</Dialog>
		</React.Fragment>
	);
}
